import { NavItemButton } from '@liscio/common';
import {
  Icon,
  Menu,
  useMenuAnchor,
  MenuItem,
  ListItemText,
  ListItemIcon,
  ListItem,
  Stack,
  Box,
} from '@liscio/ui';

import MoreMenuItem from '../MoreMenuItem/MoreMenuItem';
import { routes } from 'routes';

export const OptionsMenuItem = () => {
  const { anchorEl, open, onOpen, onClose } = useMenuAnchor();

  return (
    <>
      <ListItem
        disablePadding
        data-testid="sidebar__options"
        onClick={onOpen}
        selected={open}
      >
        <NavItemButton>
          <Stack
            sx={{ width: '100%' }}
            direction="row"
            alignItems="center"
            justifyContent="center"
          >
            <Box sx={{ width: '40px' }}>
              <Icon icon="ellipsis" sx={{ width: '16px', height: '16px' }} />
            </Box>
          </Stack>
        </NavItemButton>
      </ListItem>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={onClose}
        anchorOrigin={{
          horizontal: 'right',
          vertical: 'top',
        }}
        transformOrigin={{ horizontal: 'left', vertical: 'top' }}
        slotProps={{ paper: { sx: { width: 220 } } }}
        sx={{ ml: 1, svg: { fontSize: '15px' } }}
      >
        <MoreMenuItem label="Admin" icon={<Icon icon="admin" />}>
          <MenuItem to={routes.adminUsers.link()}>
            <ListItemText>Users</ListItemText>
          </MenuItem>
          <MenuItem to={routes.adminPreferences.link()}>
            <ListItemText>Preferences</ListItemText>
          </MenuItem>
          <MenuItem to={routes.adminTemplates.link()}>
            <ListItemText>Templates</ListItemText>
          </MenuItem>
          <MenuItem to={routes.adminIntegrations.link()}>
            <ListItemText>Integrations</ListItemText>
          </MenuItem>
          <MenuItem to={routes.adminSMS.link()}>
            <ListItemText>Admin SMS</ListItemText>
          </MenuItem>
          <MenuItem to={routes.adminBilling.link()}>
            <ListItemText>System Billing</ListItemText>
          </MenuItem>
        </MoreMenuItem>
        <MenuItem to={routes.logout.link()}>
          <ListItemIcon>
            <Icon icon="logout" />
          </ListItemIcon>
          <ListItemText>Logout</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};
